import { api_POST, api_PUT } from "services/api_service.js";

export const EnviaProtocoloWithProtocoloTransportador = (json, callback) => {
    if (json.protocolo_Id == 0)
    {
        api_POST('protocoloTransportador/PostProtocoloWithProtocoloTransportador',json).then(result => {
            callback(result);        
        });
    }
    else
    {
        api_PUT('protocoloTransportador/PutProtocoloWithProtocoloTransportador',json).then(result => {
            callback(result);
        });
    }
}

export const EnviaProtocoloTransportadorVeiculo = (json, callback) => {
    if (json.protocoloTransportadorVeiculo_Id == 0)
    {
        api_POST('protocoloTransportador/PostProtocoloTransportadorVeiculo',json).then(result => {
            callback(result);        
        });
    }
    else 
    {
        api_PUT('protocoloTransportador/PutProtocoloTransportadorVeiculo',json).then(result => {
            callback(result);        
        });
    }
}

export const EnviaProtocoloTransportadorLocalGuarda = (json, callback) => {
    if (json.protocoloTransportadorLocalGuarda_Id == 0)
    {
        api_POST('protocoloTransportador/PostProtocoloTransportadorLocalGuarda',json).then(result => {
            callback(result);        
        });
    }
    else 
    {
        api_PUT('protocoloTransportador/PutProtocoloTransportadorLocalGuarda',json).then(result => {
            callback(result);        
        });
    }
}

export const EnviaProtocoloTransportadorLocalDestino = (json, callback) => {
    if (json.protocoloTransportadorLocalDestino_Id == 0)
    {
        api_POST('protocoloTransportador/PostProtocoloTransportadorLocalDestino',json).then(result => {
            callback(result);        
        });
    }
    else 
    {
        api_PUT('protocoloTransportador/PutProtocoloTransportadorLocalDestino',json).then(result => {
            callback(result);        
        });
    }
}

export const EnviaProtocoloTransportadorEquipamento = (json, callback) => {
    if (json.protocoloTransportadorEquipamento_Id == 0)
    {
        api_POST('protocoloTransportador/PostProtocoloTransportadorEquipamento',json).then(result => {
            callback(result);        
        });
    }
    else 
    {
        api_PUT('protocoloTransportador/PutProtocoloTransportadorEquipamento',json).then(result => {
            callback(result);        
        });
    }
}

export const EnviaProtocoloDocumentoTransportador = (json, callback) => {    
    api_POST('protocoloTransportador/PostProtocoloDocumento',json).then(result => {
        callback(result);        
    });
}


export const EnviaRequerimentoTransportador = (json, callback) => {
    if (json.requerimentoTransportador_Id == 0)
    {
        api_POST('requerimentoTransportador/PostRequerimentoTransportador',json).then(result => {
            callback(result);        
        });
    }
    else
    {
        api_PUT('requerimentoTransportador/PutRequerimentoTransportador',json).then(result => {
            callback(result);
        });
    }
}

export const EnviaRequerimentoTransportadorVeiculo = (json, callback) => {
    if (json.requerimentoTransportadorVeiculo_Id == 0 || json.requerimentoTransportadorVeiculo_Id == null)
    {
        api_POST('requerimentoTransportador/PostRequerimentoTransportadorVeiculo',json).then(result => {
            callback(result);        
        });
    }
    else 
    {
        api_PUT('requerimentoTransportador/PutRequerimentoTransportadorVeiculo',json).then(result => {
            callback(result);        
        });
    }
}

export const EnviaRequerimentoTransportadorLocalGuarda = (json, callback) => {
    if (json.requerimentoTransportadorLocalGuarda_Id == 0)
    {
        api_POST('requerimentoTransportador/PostrequerimentoTransportadorLocalGuarda ',json).then(result => {
            callback(result);        
        });
    }
    else 
    {
        api_PUT('requerimentoTransportador/PutrequerimentoTransportadorLocalGuarda',json).then(result => {
            callback(result);        
        });
    }
}

export const EnviaRequerimentoTransportadorLocalDestino = (json, callback) => {
    if (json.requerimentoTransportadorLocalDestino_Id == 0)
    {
        api_POST('requerimentoTransportador/PostrequerimentoTransportadorLocalDestino',json).then(result => {
            callback(result);        
        });
    }
    else 
    {
        api_PUT('requerimentoTransportador/PutrequerimentoTransportadorLocalDestino',json).then(result => {
            callback(result);        
        });
    }
}

export const EnviaRequerimentoTransportadorEquipamento = (json, callback) => {
    if (json.requerimentoTransportadorEquipamento_Id == 0)
    {
        api_POST('requerimentoTransportador/PostrequerimentoTransportadorEquipamento',json).then(result => {
            callback(result);        
        });
    }
    else 
    {
        api_PUT('requerimentoTransportador/PutrequerimentoTransportadorEquipamento',json).then(result => {
            callback(result);        
        });
    }
}

export const EnviaRequerimentoDocumentoTransportador = (json, callback) => {
    api_POST('requerimento/PostrequerimentoDocumento',json).then(result => {
        callback(result);        
    });
}

